<template>
  <div>
    <b-table hover bordered :items="codes">
      <template v-slot:cell()="data">
        <span class="heavy"><b>{{ data.value }}</b></span>
      </template>
      <template v-slot:cell(Description)="data">
        {{ data.value }}
      </template>
      <template v-slot:cell(GST%)="data">
        <b>{{ data.value }}%</b>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: ['eights'],
  data: () => ({
    show: false
  }),
  computed: {
    codes () {
      return this.eights.codes.map(item => {
        return {
          'HS Code': Object.keys(item)[0],
          Description: Object.values(item)[0],
          'GST%': this.eights.gst
        }
      })
    }
  }
}
</script>
